<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position:absolute;
  display: flex;
  border: hidden;
  padding: 0;
  margin: 0;
  top:0;
  left:0;
  height: 100%;
  width: 100%;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue